<template>
  <div>
    <div v-if="local">
      <h2 class="mb-4">Commencement</h2>
      <notification-box
        type="info"
        class="mb-4"
        :flat="true"
      >
        <div class="py-1">
          <div class="font-weight-medium mb-2">Instructions</div>
          <p>
            You must choose when this power of attorney is to commence
            operation. Select the option that corresponds to when you want this
            power of attorney to operate.
          </p>
        </div>
      </notification-box>

      <div class="mb-4">
        <item-select
          v-for="item in commencementOptions.slice(0, -1)"
          :key="item.key"
          :value="item.key === localFormatted.commencement"
          @select="selectCommencementOption(item.key)"
          :title="item.label"
          :text="item.text"
          class="mb-2"
        />
        <item-select
          :key="otherOption.key"
          :value="otherOption.key === localFormatted.commencement"
          @select="selectCommencementOption(otherOption.key)"
          :title="otherOption.label"
          :text="otherOption.text"
        >
          <v-expand-transition>
            <div
              v-if="otherOption.key === localFormatted.commencement"
              class="mx-4"
            >
              <h4 class="my-4">
                Please specify when this Enduring Power of Attorney commences:
              </h4>
              <v-textarea
                :rules="[maxLengthRule]"
                v-bind="textAreaFieldGrow"
                v-model="local.commencementOther"
                :error-messages="
                  showErrors.commencementOther &&
                  errorMessages.commencementOther
                    ? errorMessages.commencementOther
                    : null
                "
              />
              <p>
                If you are including a date in this section, you must ensure it
                is after the date that the document will be signed.
              </p>
            </div>
          </v-expand-transition>
        </item-select>
        <v-input
          :error-messages="
            showErrors.commencement && errorMessages.commencement
              ? errorMessages.commencement
              : null
          "
        />
      </div>

      <div class="d-flex align-center">
        <v-btn
          v-bind="backButton"
          @click="close"
          ><v-icon left>mdi-chevron-left</v-icon>{{ closeLabel }}</v-btn
        >
        <v-spacer />
        <v-btn
          v-bind="buttonType"
          depressed
          @click="submit"
          >{{ submitLabel }}</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import forms from '../../../mixins/forms.js'
import { isEmptyTrimmed, trimIfExists } from '../../../utils'
import { commencementOptions } from '../../epaLists'

const storeName = 'poa_nsw_epa'
const documentId = 'poaNswEpa'

export default {
  name: 'Commencement',
  mixins: [forms(storeName, documentId)],
  data: () => ({
    showErrors: {
      commencement: false,
      commencementOther: false,
    },
    commencementOptions: commencementOptions,
    otherOption: commencementOptions[commencementOptions.length - 1],
  }),
  methods: {
    async save() {
      this.$store.dispatch('account/save_poa', {
        id: documentId,
        data: {
          ...this.localFormatted,
          commencementOther: trimIfExists(
            this.localFormatted.commencementOther
          ),
        },
      })
    },
    selectCommencementOption(key) {
      this.setAllShowErrors(false)
      this.local.commencement = key
    },
  },
  computed: {
    errorMessages() {
      let msgs = {}
      Object.keys(this.showErrors).forEach((field) => {
        msgs[field] = null
      })
      if (!this.local.commencement)
        msgs.commencement = 'Please select an option'
      if (
        this.localFormatted.commencement === 'other' &&
        isEmptyTrimmed(this.local.commencementOther)
      )
        msgs.commencementOther =
          "You have selected 'Other'. Please specify the details."
      return msgs
    },
    localFormatted() {
      return {
        commencement: this.local.commencement,
        commencementOther:
          this.local.commencement === 'other'
            ? this.local.commencementOther
            : null,
      }
    },
  },
}
</script>
